import styled from 'styled-components';
import { Typography } from '@mui/material';
export const AppTypography = styled(Typography) ``;
